import { AcademyLock } from "../../../icons/academy-icons";
import { OpcCoin } from "../../../icons/tags-icons";

const LockedOverlay = ({ blur, price }: { blur: boolean; price?: number }) => {
  return (
    <div
      className={`absolute ${blur ? "backdrop-blur-sm" : "bg-black/50"} z-10 w-full h-full rounded-xl-10 top-0 right-0`}
    >
      <div
        className={`absolute w-16 h-16 m-auto top-0 ${price ? "bottom-16" : "bottom-0"} left-0 right-0 rounded-full bg-[#ecd996] flex justify-center items-center`}
      >
        <AcademyLock width={36} height={36} strokeColor="#000" />
      </div>
      {price ? (
        <div className="absolute w-fit h-fit m-auto px-2 gap-1 py-1 top-16 bottom-0 left-0 right-0 rounded-[52px] bg-neutral-800 flex justify-center items-center">
          <OpcCoin />
          <p className="text-white font-bold text-lg">{price}</p>
        </div>
      ) : null}
    </div>
  );
};

export default LockedOverlay;
